import React from 'react';
import { Field } from 'redux-form';
import { Checkbox } from 'semantic-ui-react';

const ApprovalConfigSection = () => {
  return (
    <div style={{ marginTop: '1em' }}>
      <strong>Approval Configuration</strong>
      <div style={{ marginTop: '0.5em' }}>
        <Field
          name="approval_required"
          component={({ input }) => (
            <Checkbox
              label="Required (for manual invoice creation by Telesales / Sales)"
              checked={input.value}
              onChange={(e, { checked }) => input.onChange(checked)}
            />
          )}
        />
      </div>
    </div>
  );
};

export default ApprovalConfigSection;
